//ローディング
import {loading} from "../include/module";
loading();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//ヘッダーの開閉
import {headerToggle} from "../include/module";
headerToggle();

// Headerスクロール時
import {scrolledHeader} from "../include/module";
scrolledHeader();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// YouTubeのモーダル
import {youtubeModal} from "../include/module";
youtubeModal();

// サンクスページ
const toThanks = () => {
  document.addEventListener( 'wpcf7mailsent', function( event ) {
    location = '/contact/thanks/';
  }, false );
};
toThanks();



// WEBPACK FOOTER //
// ./src/stronger/assets/js/contact/script.js